export default __webpack_public_path__ + "static/media/document.8538cb82.svg";